import olMap from 'ol/Map';
import WKT from 'ol/format/WKT';
import * as olExtent from 'ol/extent';
import { Coordinate } from "ol/coordinate";

/**
 * View navigation helpers: fit to WKT/extent, minimum-zoom animation and
 * WKT coordinate extraction.
 */
export class MapNavigator {

    public constructor(private _map: olMap) {
    }

    public getCoordinateFromWkt = (wkt: string): Coordinate | null => {
        if (!wkt) {
            return null;
        }
        let format = new WKT();
        let geom = format.readGeometry(wkt, {
            dataProjection: "EPSG:27700",
            featureProjection: "EPSG:3857"
        });
        const center = olExtent.getCenter(geom.getExtent());
        return geom.getClosestPoint(center);
    }

    public fitMapToWkt = (wkt: string): void => {
        if (!wkt) {
            return;
        }
        let format = new WKT();
        let geom = format.readGeometry(wkt, {
            dataProjection: "EPSG:27700",
            featureProjection: "EPSG:3857"
        });
        this.fitMapToExtent(geom.getExtent());
    }

    public fitMapToExtent = (extent: olExtent.Extent): void => {
        if (!extent) {
            return;
        }
        this._map.getView().fit(extent, { maxZoom: 16, nearest: false });
    }

    public ensureMinimumZoom = (coordinate: Coordinate, minZoom: number, callback: () => void): void => {
        const view = this._map.getView();
        const currentZoom = view.getZoom();
        if (currentZoom === undefined) {
            callback();
            return;
        }

        if (currentZoom < minZoom) {
            if (coordinate) {
                view.animate({ center: coordinate, zoom: minZoom }, () => callback());
            } else {
                view.animate({ zoom: minZoom }, () => callback());
            }
        } else {
            callback();
        }
    }
}
